// ----------------------------------------------------------------------

import { color } from "framer-motion";

export function remToPx(value) {
  return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value) {
  return `${value / 16}rem`;
}

export function responsiveFontSizes({ sm, md, lg }) {
  return {
    '@media (min-width:600px)': {
      fontSize: pxToRem(sm),
    },
    '@media (min-width:900px)': {
      fontSize: pxToRem(md),
    },
    '@media (min-width:1200px)': {
      fontSize: pxToRem(lg),
    },
  };
}

const primaryFont = '"Poppins", sans-serif'; // Google Font
// const secondaryFont = 'CircularStd, sans-serif'; // Local Font

// ----------------------------------------------------------------------

export const typography = {
  fontFamily: primaryFont,
  fontWeightRegular: 300,
  fontWeightMedium: 400,
  fontWeightSemiBold: 500,
  fontWeightBold:600,
  h1: {
    fontWeight: 700,
    lineHeight: 80 / 64,
    fontSize: pxToRem(40),
    ...responsiveFontSizes({ sm: 52, md: 58, lg: 64 }),
  },
  h2: {
    fontWeight: 600,
    lineHeight: 64 / 48,
    fontSize: pxToRem(32),
    ...responsiveFontSizes({ sm: 40, md: 44, lg: 48 }),
  },
  h3: {
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(24),
    ...responsiveFontSizes({ sm: 26, md: 30, lg: 32 }),
  },
  h4: {
    fontWeight: 500,
    lineHeight: 2,
    fontSize: pxToRem(20),
    ...responsiveFontSizes({ sm: 22, md: 24, lg: 24 }),
  },
  h5: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 19, md: 20, lg: 20 }),
  },
  h6: {
    fontWeight: 400,
    lineHeight: 10 / 18,
    fontSize: pxToRem(17),
    ...responsiveFontSizes({ sm: 18, md: 18, lg: 18 }),
  },
  subtitle1: {
    fontWeight: 300,
    lineHeight: 1.5,
    fontSize: pxToRem(14),
  },
  subtitle11: {
    fontWeight: 400,
    lineHeight: 1,
    fontSize: pxToRem(12),
  },
  trainer1: {
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(13),
  },
  subtitle2: {
    fontWeight: 300,
    lineHeight: 22 / 14,
    fontSize: pxToRem(12),
  },
  subtitle3: {
    fontWeight: 500,
    lineHeight: 1.5,
    fontSize: pxToRem(15),
  },
  subtitle4: {
    fontWeight: 400,
    lineHeight: 1,
    fontSize: pxToRem(17),
  },
  subtitle6: {
    fontWeight: 400,
    lineHeight: 1,
    fontSize: pxToRem(14),
  },
  subtitle8: {
    fontWeight: 700,
    lineHeight: 1.3,
    fontSize: pxToRem(11.5),
  },
  subtitle9: {
    fontWeight: 500,
    lineHeight: 2.5,
    fontSize: pxToRem(12),
  },
  subtitle7: {
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(13),
  },
  body1: {
    fontWeight: 400,
    lineHeight: 1,
    fontSize: pxToRem(13),
  },
  body2: {
    lineHeight: 22 / 14,
    fontSize: pxToRem(14),
  },
  body3: {
    fontWeight: 400,
    lineHeight: 1,
    fontSize: pxToRem(11),
  },
  body4: {
   fontWeight: 300,
    lineHeight: 1,
    fontSize: pxToRem(12),
  },
  body5: {
   fontWeight: 500,
    lineHeight: 1,
    fontSize: pxToRem(13),
  },
  body6: {
    fontWeight: 500,
     lineHeight: 1.2,
     fontSize: pxToRem(15),
   },
   body8: {
    fontWeight: 600,
     lineHeight: 2,
     fontSize: pxToRem(20),
     letterSpacing: '0.9px',
   },
   body7: {
    fontWeight: 600,
     lineHeight: 0.8,
     fontSize: pxToRem(13),
   },
   
  caption: {
    lineHeight: 1.5,
    fontSize: pxToRem(12),
  },
  overline: {
    fontWeight: 700,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    textTransform: 'uppercase',
  },
  button: {
    fontWeight: 700,
    lineHeight: 24 / 14,
    fontSize: pxToRem(14),
    textTransform: 'unset',
  },
};
